<template>
  <ModalCard>
    <template #body>
      <div class="is-flex is-justify-content-center">
        <div style="width: 50%">
          <div class="is-flex is-align-items-center is-justify-content-space-between m-b-30">
            <h1 class="title is-size-1 m-b-10 has-text-grey-dark">
              {{ $t('ops.time-tracking') }}
            </h1>
            <TimeEntryWeeksNavigator
              @on-week-change="setWeekDates"
              :initial-week-date="initialDateString"
            />
          </div>
          <p class="title is-size-3 m-b-10 has-text-grey-dark">
            {{ $t('CE Investments') }}
          </p>
          <section class="columns is-multiline">
            <div class="column is-6" v-for="subType in subTypes" :key="subType.key">
              <GenericTimeEntryCard
                :label="subType.value"
                :color="TimeEntryType.CEI.color"
                :type="TimeEntryType.CEI.key"
                :initial-date="initialDate"
                :sub-type="subType.key"
                :week-dates="weekDates"
                :disabled="subType.readonly"
              />
            </div>
          </section>
          <p class="title is-size-3 m-b-10 m-t-20 has-text-grey-dark">
            {{ $t('Other') }}
          </p>
          <section class="columns is-multiline">
            <div class="column is-6">
              <GenericTimeEntryCard
                :label="TimeEntryType.PTO.value"
                :color="TimeEntryType.PTO.color"
                :type="TimeEntryType.PTO.key"
                :initial-date="initialDate"
                :week-dates="weekDates"
              />
            </div>
            <div class="column is-6">
              <GenericTimeEntryCard
                :label="TimeEntryType.NON_WORK_RELATED.value"
                :color="TimeEntryType.NON_WORK_RELATED.color"
                :type="TimeEntryType.NON_WORK_RELATED.key"
                :initial-date="initialDate"
                :week-dates="weekDates"
              />
            </div>
          </section>
        </div>
      </div>
    </template>
  </ModalCard>
</template>

<script>
import ModalCard from '@/modules/core/ui/components/ModalCard.vue';
import { TimeEntryType } from '@/modules/timeentry/enums/TimeEntryType';
import { TimeEntrySubType } from '@/modules/timeentry/enums/TimeEntrySubType';
import GenericTimeEntryCard from '@/modules/timeentry/components/stateful/GenericTimeEntryCard.vue';
import TimeEntryWeeksNavigator from '@/modules/ops/components/presentational/TimeEntryWeeksNavigator.vue';
import { datesOfWeek, isInThisWeek } from '@/modules/core/app/helpers/DateHelper';
import dayjs from 'dayjs';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'GenericTimeEntryModal',
  components: { TimeEntryWeeksNavigator, GenericTimeEntryCard, ModalCard },
  props: {
    initialDateString: {
      type: String,
      default: () => dayjs().toString()
    }
  },
  static: {
    TimeEntryType,
    TimeEntrySubType
  },
  data() {
    return {
      initialDate: dayjs(this.initialDateString).toDate(),
      weekDates: datesOfWeek(dayjs(this.initialDateString), false)
    };
  },
  computed: {
    subTypes() {
      return TimeEntrySubType.getValues();
    }
  },
  methods: {
    setWeekDates(weekDates) {
      this.weekDates = weekDates;
      this.initialDate = isInThisWeek(this.weekDates[0])
        ? dayjs().toDate()
        : dayjs(this.weekDates[0]).toDate();
    }
  }
};
</script>

<style scoped>
div.column {
  padding-top: var(--ce-5px);
  padding-bottom: var(--ce-5px);
}
</style>
